<template>
  <e-card @toggleDrag="$emit('toggleDrag')" :class="sizeClasses" class="kyc-wizard" data-v-step="8">
    <b-tab title="KYC Status" class="e-card__content" v-if="!loading">
      <p>The KYC procedure is a simple online process of identification. Participants will need to provide a high-quality image of a passport or government-issued ID.</p>
      <p>Complete your KYC verification and start buying crypto with us!</p>
      <e-button @click="showKycModal">{{ buttonText }}</e-button>
      <p class="limit">Current trading limit: <b>${{ tradingLimit }}</b></p>
      
      <e-hint title="Note:">
        Economix is implementing the KYC procedure to address concerns from specific countries regulators. Our team also believes that it symbolizes better business practice and it is beneficial to all parties!
      </e-hint>
    </b-tab>
  </e-card>
</template>

<script>
  import ECard from '../../elements/card/card';
  import DynamicSizeMixin from '../../../mixins/dynamicSize';
  import _ from 'lodash';
  import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
  import Services from '../../../services';
  import TCard from "./../../elements/trading/card.vue";  

  export default {
		name: "ec-kyc",
    mixins: [DynamicSizeMixin],
    components: {ECard, TCard},
    filters: {
      shortText(value) {
		    if(value.length > 25) {
          value = value.substring(0, 22) + '...'
        }

        return value
      }
    },
    methods: {
      ...mapMutations("settings", ["setShowKyc"]),
      onSeeAllClick() {
        this.$router.push({name: 'trading-buy'})
      },
      showKycModal() {
        this.setShowKyc(true);
      }
    },
    data() {
      return {
        loading: true,
        kycUser: {},
      }
    },
    computed: {
      ...mapGetters("coins", {
        getCoins: 'coins'
      }),
      buttonText() {
        switch(this.kycUser.kycStatus) {
          case 'Tier0':
            return 'Up to 15K USD';
          case 'Tier1':
            return 'Up to 500K USD';
          case 'Tier2':
            return 'Up to 1M USD';
        }
      },
      tradingLimit() {
        return parseFloat(this.kycUser.amountLimit).toFixed(2)
      }
    },
    async mounted() {
      this.loading = true;
      this.kycUser = await Services.Auth.getKYCUser();
      this.loading = false;
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/kyc/kyc.vue